import i18n from '@/locales/i18n'

const columns = [
    {
        title: i18n.t('driverList.driverName'),
        dataIndex: "name",
        width: "80px",
        align: "center"
    },
    {
        title: i18n.t('businessDispatch.contactNumber'),
        dataIndex: "mobile",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('driverList.IDCard'),
        dataIndex: "idCardNumber",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('edit'),
        dataIndex: 'edit',
        width: "120px",
        align: "center",
        scopedSlots: { customRender: 'edit' }
    },

    // {   
    //     title: "ID",
    //     dataIndex: "id",
    //     width: "40px",
    //     align: "center"
    // },
    // {   
    //     title: "公司ID",
    //     dataIndex: "companyId",
    //     width: "120px",
    //     align: "center"
    // },


    // {
    //     title: "创建时间",
    //     dataIndex: "createdTime",
    //     width: "100px",
    //     align: "center"
    // },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatedTime",
    //     width: "100px",
    //     align: "center"
    // }
];


export {
    columns,
}